export const SELECT = 'SELECT'
export const REQUEST_DATA = 'REQUEST_DATA'
export const RECEIVE_DATA = 'RECIEVE_DATA'
export const LOG_IN = 'LOG_IN'
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'
export const LOG_IN_FAILURE = 'LOG_IN_FAILURE'
export const LOG_OUT = 'LOG_OUT'
export const LOG_OUT_SUCCESS = 'LOG_OUT_SUCCESS'
export const LOG_OUT_FAILURE = 'LOG_OUT_FAILURE'
export const TOGGLE_TRIGGERS = 'TOGGLE_TRIGGERS'
export const SHOW_MAXIMIZED_CHART = 'SHOW_MAXIMIZED_CHART'
export const HIDE_MAXIMIZED_CHART = 'HIDE_MAXIMIZED_CHART'

export function select(key, value, dashboard = 'UNKNOWN') {
  return { type: SELECT, key: key, value: value, dashboard: dashboard }
}

export function requestData() {
  return { type: REQUEST_DATA }
}

export function receiveData(data) {
  return { type: RECEIVE_DATA, data: data }
}

export function fetchData() {
  return function (dispatch) {
    dispatch(requestData());

    return fetch(`../data.json`)
      .then(
      response => response.json(),
      error => console.log('An error occured.', error)
      )
      .then(json =>
        dispatch(receiveData(json))
      )
  }
}

export function logIn(email, password) {
  return { type: LOG_IN, email: email, password: password }
}

export function logInSuccess(email) {
  return { type: LOG_IN_SUCCESS, email: email }
}

export function logInFailure(error) {
  return { type: LOG_IN_FAILURE, error: error }
}

export function logOut() {
  return { type: LOG_OUT }
}

export function logOutSuccess() {
  return { type: LOG_OUT_SUCCESS }
}

export function logOutFailure(error) {
  return { type: LOG_IN_FAILURE, error: error }
}

export function login(email, password, firebase) {
  return function (dispatch) {
    dispatch(logIn(email, password, firebase));

    return firebase
      .login({ email: email, password: password })
      .then(() => {
        console.log('Succesfully logged in');
        dispatch(logInSuccess(email));
      })
      .catch((error) => {
        console.log('there was an error', error);
        dispatch(logInFailure(error));
      });
  }
}

export function logout(firebase) {
  return function (dispatch) {
    dispatch(logOut());

    return firebase
      .logout()
      .then(() => {
        console.log('Succesfully logged out')
        dispatch(logOutSuccess());
      })
      .catch((error) => {
        console.log('there was an error', error);
        dispatch(logOutFailure(error));
      });
  }
}

export function toggleTriggers() {
  return { type: TOGGLE_TRIGGERS }
}

export function showMaximizedChart(chart) {
  return { type: SHOW_MAXIMIZED_CHART, chart: chart }
}

export function hideMaximizedChart() {
  return { type: HIDE_MAXIMIZED_CHART }
}


// WEBPACK FOOTER //
// ./src/actions/index.js